<template>
  <div class="main_view">
    <el-container>
      <!--导航栏-->
      <el-header>
        <div class="yy_head">
          <div class="yy_head_left">
            <div class="yy_head_logo">
              <a href="/#/" target="_blank">
                <img src="/static/images/bigdata/maoyan_logo.png"/>
              </a>
            </div>
            <div class="yy_head_line"></div>
            <div class="yy_head_title">
              <span>博主报名</span>
            </div>
          </div>
        </div>
      </el-header>
      <!--内容栏-->
      <el-main>
        <!--需求栏-->
        <div style="margin-bottom: 10px; margin-top: 10px; width: 100%;">---需求详情---</div>
        <el-table
          :data="datalist"
          border
          style="background-color: #FFFFFF; margin-bottom: 10px; margin-top: 10px; width: 100%;">
          <el-table-column
            prop="pr_wechat"
            label="PR微信"
            width="120">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="campaign"
            label="活动标题"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="product"
            label="产品名称"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="gift"
            label="赠品信息"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="location"
            label="探店地址"
            width="100">
          </el-table-column>
          <el-table-column
            prop="c_type"
            label="创作类型"
            width="80">
          </el-table-column>
          <el-table-column
            prop="date_s"
            label="开始日期"
            width="120">
          </el-table-column>
          <el-table-column
            prop="date_e"
            label="结束日期"
            width="120">
          </el-table-column>
          <el-table-column
            prop="reward_s"
            label="最小报酬"
            width="100">
          </el-table-column>
          <el-table-column
            prop="reward_e"
            label="最大报酬"
            width="100">
          </el-table-column>
          <el-table-column
            prop="platform"
            label="博主平台"
            width="100">
          </el-table-column>
          <el-table-column
            prop="gender"
            label="博主性别"
            width="80">
          </el-table-column>
          <el-table-column
            prop="fans_s"
            label="博主最小粉丝"
            width="120">
          </el-table-column>
          <el-table-column
            prop="fans_e"
            label="博主最大粉丝"
            width="120">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="category"
            label="博主类目"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="p_location"
            label="博主地域"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="p_type"
            label="博主身份"
            width="100">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="detail_r"
            label="详细需求"
            width="200">
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 10px; margin-top: 10px; width: 100%;">---报名信息---</div>
        <!--筛选栏-->
        <div class="yy_filter" style="background-color: #FFFFFF; padding-top: 20px; padding-bottom: 20px; margin-bottom: 10px; ">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="*报名平台">
                <el-radio-group v-model="form.platform">
                  <el-radio label="小红书" value="小红书"></el-radio>
                  <el-radio label="抖音" value="抖音"></el-radio>
                  <el-radio label="淘宝" value="淘宝"></el-radio>
                  <el-radio label="知乎" value="知乎"></el-radio>
                  <el-radio label="B站" value="B站"></el-radio>
                  <el-radio label="得物" value="得物"></el-radio>
                  <el-radio label="大众点评" value="大众点评"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="*主页链接">
                <el-col :span="18">
                  <el-input v-model="form.url" placeholder="请填写个人主页链接"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*粉丝数">
                <el-col :span="18">
                  <el-input-number v-model="form.fans" controls-position="right" placeholder="请填写粉丝数"></el-input-number>
                </el-col>
              </el-form-item>

              <el-form-item label="*图文报价">
                <el-col :span="18">
                  <el-input-number v-model="form.image_price" controls-position="right" placeholder="请填写图文报价(元)"></el-input-number>
                </el-col>
              </el-form-item>

              <el-form-item label="*视频报价">
                <el-col :span="18">
                  <el-input-number v-model="form.video_price" controls-position="right" placeholder="请填写视频报价(元)"></el-input-number>
                </el-col>
              </el-form-item>

              <el-form-item label="*手机号">
                <el-col :span="18">
                  <el-input v-model="form.phone" placeholder="请填写手机号"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*微信号">
                <el-col :span="18">
                  <el-input v-model="form.wechat" placeholder="请填写微信号"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*个人类目">
                <el-checkbox-group v-model="form.category">
                  <el-checkbox label="美妆" value="美妆"></el-checkbox>
                  <el-checkbox label="护肤" value="护肤"></el-checkbox>
                  <el-checkbox label="个人护理" value="个人护理"></el-checkbox>
                  <el-checkbox label="母婴" value="母婴"></el-checkbox>
                  <el-checkbox label="时尚" value="时尚"></el-checkbox>
                  <el-checkbox label="美食" value="美食"></el-checkbox>
                  <el-checkbox label="家居家装" value="家居家装"></el-checkbox>
                  <el-checkbox label="影视综资讯" value="影视综资讯"></el-checkbox>
                  <el-checkbox label="运动健身" value="运动健身"></el-checkbox>
                  <el-checkbox label="宠物" value="宠物"></el-checkbox>
                  <el-checkbox label="文化艺术" value="文化艺术"></el-checkbox>
                  <el-checkbox label="兴趣爱好" value="兴趣爱好"></el-checkbox>
                  <el-checkbox label="生活记录" value="生活记录"></el-checkbox>
                  <el-checkbox label="教育" value="教育"></el-checkbox>
                  <el-checkbox label="职场" value="职场"></el-checkbox>
                  <el-checkbox label="情感" value="情感"></el-checkbox>
                  <el-checkbox label="摄影" value="摄影"></el-checkbox>
                  <el-checkbox label="游戏" value="游戏"></el-checkbox>
                  <el-checkbox label="科技数码" value="科技数码"></el-checkbox>
                  <el-checkbox label="出行旅游" value="出行旅游"></el-checkbox>
                  <el-checkbox label="音乐" value="音乐"></el-checkbox>
                  <el-checkbox label="搞笑" value="搞笑"></el-checkbox>
                  <el-checkbox label="健康养生" value="健康养生"></el-checkbox>
                  <el-checkbox label="汽车" value="汽车"></el-checkbox>
                  <el-checkbox label="婚嫁" value="婚嫁"></el-checkbox>
                  <el-checkbox label="商业财经" value="商业财经"></el-checkbox>
                  <el-checkbox label="素材" value="素材"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <div class="yy_filter_btn">
                  <el-button type="primary" @click="onSubmit()">提交报名</el-button>
                </div>
              </el-form-item>
            </el-form>
        </div>
      </el-main>
      <!--底部导航-->
<!--      <el-footer>-->
<!--        <div class="yy_bottom">COPYRIGHT  2020-2024 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>-->
<!--      </el-footer>-->
    </el-container>
  </div>
</template>


<script>
import moment from "moment";
import {Base64} from 'js-base64';
import process from "shelljs";
export default {
  name: "YYZhaomu",
  data() {
    return {
      datalist: [],
      form: {
        pk: '',
        platform: '',
        fans: '',
        url: '',
        category: [],
        image_price: '',
        video_price: '',
        phone: '',
        wechat: '',
        sign: '',
      },
    }
  },
  methods: {
    getListData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/yy_requests_detail';
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
          'request_id': this.form.pk,
        })
      }).then((res) => {
        console.log("res ", res);
        let data = res.data;
        if (data.error === 0) {
          this.datalist = data.result;
        } else {
          this.$message({
            showClose: true,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("res ", res);
        this.$message({
          showClose: true,
          message: res,
          type: 'error'
        });
      })
    },
    onSubmit(val) {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      this.form.sign = Base64.encode('Maozhou2024' + sendTime);
      this.form.yy_action = val;
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/maoyaoyue_zhaomu_create';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: this.form,
      }).then((res) => {
        console.log("res ", res);
        let data = res.data;
        if (data.error === 0) {
            this.$alert('报名成功', '操作提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
        } else {
          this.$message({
            showClose: true,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("res ", res);
        this.$message({
          showClose: true,
          message: res,
          type: 'error'
        });
      })
    }
  },
  mounted () {
    // 加载数据
    this.form.pk = this.$route.query.request_id;
    if (this.form.pk !== '') {
      this.getListData();
    }
  },
  metaInfo: {
    title: "袤周-AI智能找“人”工具",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  width 100%
  background-color #f5f7fc
  .el-header
    padding 0
    top 0
    position sticky
    z-index 10
    background-color $white
    .yy_head
      background-color $white
      box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
      width 100%
      display flex
      .yy_head_left
        padding-left 12%
        display flex
        flex-direction row
        .yy_head_logo
          height 60px
          img
            height 50px
            padding-top 5px
        .yy_head_line
          margin-left 10px
          width 1px
          height 60px
          background-color $colorE
        .yy_head_title
          margin-left 15px
          color $color-two
          font-size 20px
          font-weight bold;
          width auto
          display flex
          position relative
          height 60px
          flex-direction row
          align-items center

      .yy_head_right
        height 60px
        width auto
        margin-left auto
        padding-right 12%
        display flex
        flex-direction row
        .yy_head_btn
          display flex
          align-items center
          margin-right 10px
        .yy_head_user
          display flex
          flex-direction row
          height 60px
          .yy_head_user_img
            margin-top 10px
            margin-left 10px
            height 40px
            width 40px
            border-radius 60px
          .yy_head_user_nickname
            color #000000
            font-size 14px
            margin-left 10px
            display flex
            align-items center
          .yy_head_user_logout
            margin-right 12%
            position absolute
            width 120px
            height 38px
            display flex
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey

  .el-container
    padding 0

  .el-main
    padding 0
    padding-left 5%
    padding-right 5%
    .yy_filter
      .el-form
        padding 0
        .yy_filter_btn
          margin-right 80px
          display flex
          justify-content center


  .el-footer
    padding 0
    margin-top 20px
    bottom 0
    left 0
    width 100%
    .yy_bottom
      background linear-gradient(135deg, rgba(51,51,51,1) 0%, rgba(17,17,17,1) 100%)
      height auto
      display flex
      flex-direction row
      color $white
      justify-content center
      align-items center
      a
        margin-left: 10px
        margin-top 20px
        margin-bottom 20px
        color $white
</style>




// WEBPACK FOOTER //
// src/components/yaoyue/YYZhaomu.vue